// @ts-ignore
import { Popover } from 'bootstrap';

window.addEventListener('DOMContentLoaded', (event) => {
    const selector = '[data-bs-toggle="popover"]';

    Array.from(document.querySelectorAll(selector)).forEach(popover => {
        new Popover(popover);
    });
});
